import { default as defaultExport } from "@cloudflare/unenv-preset/node/process";
globalThis.process = defaultExport;